<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />

    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'
import locationServices from '@/services/api/location.api'
export default {
  name: 'ActiveSchoolsReport',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        filters: {
          academicYear: null,
          region: null,
          center: null,
          districtId: null,
          municipalityId: null,
        },
        collections: {
          academicYears: [],
          regions: [],
          centers: [],
          districts: [],
          municipalities: [],
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Informe de las Escuelas en MiPE',
        icon:
          'fa-solid fa-magnifying-glass-chart pr-0 font-22 magnifying-glass-icon-m ',
        routes: [
          'Inicio',
          'Informe de las Escuelas en MiPE',
        ],
      }
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'El campo de año académico es requerido.',
          validations: 'required',
          class: 'col-md-3',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'region',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Región',
          placeholder: 'Seleccionar',
          class: 'col-md-2',
          options: this.model.search.collections.regions,
          value: this.model.search.filters.region,
          onChanged: this.onChangeRegion,
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Centro',
          placeholder: 'Seleccionar',
          class: 'col-md-2',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
          onChanged: this.onChangeCenter,
        },
        {
          name: 'district',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Distrito',
          placeholder: 'Seleccionar',
          class: 'col-md-2',
          options: this.model.search.collections.districts,
          value: this.model.search.filters.district,
          onChanged: this.onChangeDistrict,
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Municipio',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.model.search.collections.municipalities,
          value: this.model.search.filters.municipality,
        },
      ]
    },
  },
  async mounted() {
    await this.getInitialFilters()
  },
  methods: {
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()
      if (isValid) {
        await this.process()
      }
    },
    async getInitialFilters() {
      const { data: years } = await AcademicYearServices.getCurrentYearAcademicYears();
      this.model.search.collections.academicYears = [...years];
      this.model.search.filters.academicYear = years[0];
      await this.onChangeAcademicYear();
    },
    async onChangeAcademicYear() {
      this.model.search.filters.region = null;
      this.model.search.filters.center = null;
      this.model.search.filters.district = null;
      this.model.search.filters.municipality = null;

      this.model.search.collections.regions = (await locationServices.getRegions({ academicYearId: this.model.search.filters.academicYear?.id })).data;
    },
    async onChangeRegion() {
      this.model.search.filters.center = null;
      this.model.search.filters.district = null;
      this.model.search.filters.municipality = null;

      this.model.search.collections.centers = (await locationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear?.id,
        regionId: this.model.search.filters.region?.id
      })).data;
    },
    async onChangeCenter() {
      this.model.search.filters.district = null;
      this.model.search.filters.municipality = null;

      this.model.search.collections.districts = (await locationServices.getDistricts({
        academicYearId: this.model.search.filters.academicYear?.id,
        regionId: this.model.search.filters.region?.id,
        centerId: this.model.search.filters.center?.id
      })).data;
    },
    async onChangeDistrict() {
      this.model.search.filters.municipality = null;

      this.model.search.collections.municipalities = (await locationServices.getMunicipalities({
        academicYearId: this.model.search.filters.academicYear?.id,
        regionId: this.model.search.filters.region?.id,
        centerId: this.model.search.filters.center?.id,
        districtId: this.model.search.filters.district?.id
      })).data;
    },
    async process() {
      await ReportServices.getReport('activeschoolsreport', {
        academicYearId: this.model.search.filters.academicYear?.id,
        regionId: this.model.search.filters.region?.id,
        centerId: this.model.search.filters.center?.id,
        districtId: this.model.search.filters.district?.id,
        municipalityId: this.model.search.filters.municipality?.id,
      }).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>

<style lang="scss" scoped></style>
